/* pdp-fx.js: tap a product photo to change it. Phones slide to the next photo; desktop cross-fades. */
(function () {
  'use strict';
  var desk = window.matchMedia('(min-width: 990px)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function thumbSrc(item) {
    var img = item.querySelector('img');
    if (img) {
      var s = img.currentSrc || img.src || '';
      return /[?&]width=\d+/.test(s) ? s.replace(/([?&])width=\d+/, '$1width=160') : s;
    }
    var v = item.querySelector('video');
    return v && v.poster ? v.poster : '';
  }

  function build(g) {
    if (g._fx) return;
    var track = g.querySelector('[data-gallery-track]');
    if (!track) return;
    var items = Array.prototype.slice.call(track.querySelectorAll('.gallery__item'));
    if (items.length < 2) return;
    g._fx = true;
    g.setAttribute('data-fx', '');
    var cur = 0;

    var count = document.createElement('span');
    count.className = 'fx-count';
    count.setAttribute('aria-hidden', 'true');
    track.appendChild(count);

    var strip = document.createElement('div');
    strip.className = 'fx-thumbs';
    var btns = items.map(function (it, j) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Show picture ' + (j + 1));
      var src = thumbSrc(it);
      if (src) { var im = document.createElement('img'); im.src = src; im.alt = ''; im.loading = 'lazy'; b.appendChild(im); }
      b.addEventListener('click', function (e) { e.stopPropagation(); show(j); });
      strip.appendChild(b);
      return b;
    });
    g.appendChild(strip);

    function mod(i) { return (i + items.length) % items.length; }
    function paint(i) {
      cur = mod(i);
      items.forEach(function (it, j) { it.classList.toggle('fx-active', j === cur); });
      btns.forEach(function (b, j) { b.setAttribute('aria-current', j === cur ? 'true' : 'false'); });
      count.textContent = (cur + 1) + ' / ' + items.length;
    }
    function show(i) {
      var n = mod(i);
      if (desk.matches) { paint(n); return; }
      track.scrollTo({ left: items[n].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      paint(n);
    }

    track.addEventListener('click', function (e) {
      if (e.target.closest('a, button, iframe, [controls]')) return;
      var idx = desk.matches ? cur : Math.round(track.scrollLeft / (track.clientWidth || 1));
      show(idx + 1);
    });
    /* on phones, keep our index in step with swipes */
    track.addEventListener('scroll', function () {
      if (desk.matches) return;
      paint(Math.round(track.scrollLeft / (track.clientWidth || 1)));
    }, { passive: true });

    /* desktop: the theme's variant switcher can only scroll the phone track, so jump to the variant's photo here */
    g._fxShowMedia = function (id) {
      for (var j = 0; j < items.length; j++) {
        if (String(items[j].getAttribute('data-media-id')) === String(id)) { paint(j); return; }
      }
    };
    paint(0);
  }

  function init(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-gallery]'), build);
  }

  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('[data-opt]') || !desk.matches) return;
    var pd = e.target.closest('[data-product]');
    if (!pd) return;
    setTimeout(function () {
      var js = pd.querySelector('[data-product-json]'), idEl = pd.querySelector('[data-variant-id]'), g = pd.querySelector('[data-gallery]');
      if (!js || !idEl || !g || !g._fxShowMedia) return;
      var p; try { p = JSON.parse(js.textContent); } catch (x) { return; }
      var v = (p.variants || []).filter(function (x) { return String(x.id) === String(idEl.value); })[0];
      if (v && v.featured_media) g._fxShowMedia(v.featured_media.id);
    }, 0);
  });

  function boot() { init(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
